type Props = { className?: string; title?: string };

/**
 * Hexagon-and-bear-paw mark used throughout the site. Uses `currentColor`
 * so it inherits the surrounding text colour; size is set by the consumer
 * via a Tailwind className (e.g. `w-6 h-6`).
 */
export function BrandIcon({ className, title = 'Bärenfang' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      role="img"
      aria-label={title}
      className={className}
    >
      <title>{title}</title>
      <path
        d="M50 8 L85 28 L85 72 L50 92 L15 72 L15 28 Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinejoin="round"
      />
      <ellipse cx="50" cy="58" rx="13" ry="10" fill="currentColor" />
      <circle cx="34" cy="43" r="4.5" fill="currentColor" />
      <circle cx="44" cy="37" r="4.5" fill="currentColor" />
      <circle cx="56" cy="37" r="4.5" fill="currentColor" />
      <circle cx="66" cy="43" r="4.5" fill="currentColor" />
    </svg>
  );
}
